import api from 'api'
import { z } from 'zod'
import { PositionId, verificationTypeEnum } from './types'

export const positionSchema = z.object({
  id: z.number(),
  name: z.string(),
  about: z.string(),
  prescreened: z.boolean(),
  isTipEligible: z.boolean(),
  requirements2: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      category: z.string(),
      credential: z.string(),
      verifiable: z.boolean(),
      isWorkerVisible: z.boolean(),
      verificationType: z.enum(verificationTypeEnum),
    })
  ),
  mustHaveRequirements: z.array(z.object({ id: z.number() })),
  company: z.object({ id: z.number(), name: z.string() }),
})

export const getPositionRequirementsResponseSchema = z.object({
  data: z.object({ admin: z.object({ positions: z.array(positionSchema) }) }),
})

export type PositionRequirementsResponse = z.infer<
  typeof getPositionRequirementsResponseSchema
>

export const getPositionRequirements = async (positionId: PositionId) => {
  return api
    .post<PositionRequirementsResponse>(
      '/admin/graphql_dispatch/requirement_data_74f78cd1',
      { positionId }
    )
    .then((response) => response.data.data.admin.positions[0])
}
